<template>
<div id="ClusterView">

  <div id="tabela-klaster" v-if="dataCluster.powerSupply.selected && dataCluster.powerSupply.selected !== '-'">
    <h6 style="text-transform: uppercase;"><b>{{$t('message.cluster')}} {{ numer }}</b></h6>

    <table>
      <tr>
        <th>{{ $t('message.multifunction')}}</th>
        <th>{{$t('message.device')}}</th>
        <th class="midd">{{ $t('message.mpsActiveEthernet')}}</th>
        <th class="midd">{{ $t('message.mpsActiveSfp')}}</th>
      </tr>
      <tr>
        <td></td><td>{{dataCluster.powerSupply.selected}}</td>
        <td class="midd">{{dataCluster.powerSupply.ethernet}}</td>
        <td class="midd">{{dataCluster.powerSupply.sfp}}</td>
      </tr>
    </table>

    <table>
      <tr>
        <th>{{ $t('message.output24')}}</th>
        <th>{{$t('message.device')}}</th>
        <th class="midd">{{ $t('message.mpsActiveEthernet')}}</th>
        <th class="midd">{{ $t('message.maxCurrent')}}</th>
        <!-- <th class="midd">{{ $t('message.heightOtherDivice')}}</th> -->
      </tr>
      <tr>
        <td></td>
        <td>{{dataCluster.output24.selected}}</td>
        <td v-if="dataCluster.output24.ethernet" class="midd">{{dataCluster.output24.ethernet}}</td><td v-else class="midd"> - </td>
        <td v-if="dataCluster.output24.maxCurrent" class="midd">{{dataCluster.output24.maxCurrent}}</td><td v-else class="midd"> - </td>
        <!-- <td v-if="dataCluster.output24.countU" class="midd">{{dataCluster.output24.countU}}</td><td v-else class="midd"> - </td> -->
      </tr>
    </table>

    <table>
      <tr>
        <th>{{ $t('message.output48')}} 1</th>
        <th>{{$t('message.device')}}</th>
        <th class="midd short">{{ $t('message.mpsActiveEthernet')}}</th>
        <th class="midd short">{{ $t('message.totalLoudspeaker')}}</th>
        <th class="midd short">{{ $t('message.mpsActiveSfp')}}</th>
        <th class="midd short">{{ $t('message.totalPoE')}}</th>
        <th class="midd short">{{ $t('message.currentQuiescent')}}</th>
        <th class="midd short">{{ $t('message.currentAlarm')}}</th>
        <!-- <th class="midd short">{{ $t('message.heightOtherDivice')}}</th> -->
      </tr>
      <tr>
        <td></td>
        <td v-if="dataCluster.output48one.selected">{{dataCluster.output48one.selected}}</td><td v-else> - </td>
        <td v-if="dataCluster.output48one.ethernet" class="midd">{{dataCluster.output48one.ethernet}}</td><td v-else class="midd"> - </td>
        <td v-if="dataCluster.output48one.loudspeaker" class="midd">{{dataCluster.output48one.loudspeaker}}</td><td v-else class="midd"> - </td>
        <td v-if="dataCluster.output48one.sfp" class="midd">{{dataCluster.output48one.sfp}}</td><td v-else class="midd"> - </td>
        <td v-if="dataCluster.output48one.poe" class="midd">{{dataCluster.output48one.poe}}</td><td v-else class="midd"> - </td>
        <td v-if="dataCluster.output48one.currentMode" class="midd">{{dataCluster.output48one.currentMode}}</td><td v-else class="midd"> - </td>
        <td v-if="dataCluster.output48one.currentAlarm" class="midd">{{dataCluster.output48one.currentAlarm}}</td><td v-else class="midd"> - </td>
        <!-- <td v-if="dataCluster.output48one.countU" class="midd">{{dataCluster.output48one.countU}}</td><td v-else class="midd"> - </td> -->
      </tr>
    </table>

    <table>
      <tr>
        <th>{{ $t('message.output48')}} 2</th>
        <th>{{$t('message.device')}}</th>
        <th class="midd short">{{ $t('message.mpsActiveEthernet')}}</th>
        <th class="midd short">{{ $t('message.totalLoudspeaker')}}</th>
        <th class="midd short">{{ $t('message.mpsActiveSfp')}}</th>
        <th class="midd short">{{ $t('message.totalPoE')}}</th>
        <th class="midd short">{{ $t('message.currentQuiescent')}}</th>
        <th class="midd short">{{ $t('message.currentAlarm')}}</th>
        <!-- <th class="midd short">{{ $t('message.heightOtherDivice')}}</th> -->
      </tr>
      <tr>
        <td></td><td v-if="dataCluster.output48two.selected">{{dataCluster.output48two.selected}}</td><td v-else> - </td>
        <td v-if="dataCluster.output48two.ethernet" class="midd">{{dataCluster.output48two.ethernet}}</td><td v-else class="midd"> - </td>
        <td v-if="dataCluster.output48two.loudspeaker" class="midd">{{dataCluster.output48two.loudspeaker}}</td><td v-else class="midd"> - </td>
        <td v-if="dataCluster.output48two.sfp" class="midd">{{dataCluster.output48two.sfp}}</td><td v-else class="midd"> - </td>
        <td v-if="dataCluster.output48two.poe" class="midd">{{dataCluster.output48two.poe}}</td><td v-else class="midd"> - </td>
        <td v-if="dataCluster.output48two.currentMode" class="midd">{{dataCluster.output48two.currentMode}}</td><td v-else class="midd"> - </td>
        <td v-if="dataCluster.output48two.currentAlarm" class="midd">{{dataCluster.output48two.currentAlarm}}</td><td v-else class="midd"> - </td>
        <!-- <td v-if="dataCluster.output48two.countU" class="midd">{{dataCluster.output48two.countU}}</td><td v-else class="midd"> - </td> -->
      </tr>
    </table>

    <table style="width:90%;font-size: 12px;">
      <tr style="background: rgb(221, 221, 221);">
        <th>{{ $t('message.output48')}} 3</th>
        <th>{{$t('message.device')}}</th>
        <th class="midd short">{{ $t('message.mpsActiveEthernet')}}</th>
        <th class="midd short">{{ $t('message.totalLoudspeaker')}}</th>
        <th class="midd short">{{ $t('message.mpsActiveSfp')}}</th>
        <th class="midd short">{{ $t('message.totalPoE')}}</th>
        <th class="midd short">{{ $t('message.currentQuiescent')}}</th>
        <th class="midd short">{{ $t('message.currentAlarm')}}</th>
        <!-- <th class="midd short">{{ $t('message.heightOtherDivice')}}</th> -->
      </tr>
      <tr>
        <td></td><td v-if="dataCluster.output48three.selected">{{dataCluster.output48three.selected}}</td><td v-else> - </td>
        <td v-if="dataCluster.output48three.ethernet" class="midd">{{dataCluster.output48three.ethernet}}</td><td v-else class="midd"> - </td>
        <td v-if="dataCluster.output48three.loudspeaker" class="midd">{{dataCluster.output48three.loudspeaker}}</td><td v-else class="midd"> - </td>
        <td v-if="dataCluster.output48three.sfp" class="midd">{{dataCluster.output48three.sfp}}</td><td v-else class="midd"> - </td>
        <td v-if="dataCluster.output48three.poe" class="midd">{{dataCluster.output48three.poe}}</td><td v-else class="midd"> - </td>
        <td v-if="dataCluster.output48three.currentMode" class="midd">{{dataCluster.output48three.currentMode}}</td><td v-else class="midd"> - </td>
        <td v-if="dataCluster.output48three.currentAlarm" class="midd">{{dataCluster.output48three.currentAlarm}}</td><td v-else class="midd"> - </td>
        <!-- <td v-if="dataCluster.output48three.countU" class="midd">{{dataCluster.output48three.countU}}</td><td v-else class="midd"> - </td> -->
      </tr>
    </table>

    <table style="width:90%">
      <tr style="background: rgb(221, 221, 221);"><th>{{$t('message.desc')}}</th><th>{{$t('message.device')}}</th><th></th></tr>
      <tr><td>{{$t('message.callStationDesktop')}}</td><td>PRA-CSLD</td><td>{{ dataCluster.callStation.csDesktop }}</td></tr>
      <tr><td>{{$t('message.callStationWall')}}</td><td>PRA-CSLW</td><td>{{ dataCluster.callStation.csWall }}</td></tr>
      <tr><td>{{$t('message.callStationExt')}}</td><td>PRA-CSE</td><td>{{ dataCluster.callStation.csExt }}</td></tr>
      <tr><td>{{$t('message.totalPoeCST')}}</td><td></td><td>{{ dataCluster.callStation.poePorts }}</td></tr>
      <tr><td>{{$t('message.classEmerdencyCST')}}</td><td></td><td>{{ dataCluster.callStation.cstEmergency }}</td></tr>

      <tr><td>{{$t('message.noiseSensor')}} - {{$t('message.active_ports_mps_and_switch')}}</td><td></td><td>{{ dataCluster.noiseSensor.poePorts }}</td></tr>
      <tr><td>{{$t('message.interfaceControl')}} - {{$t('message.active_ports_mps_and_switch')}}</td><td></td><td>{{ dataCluster.interfaceControl.poePorts }}</td></tr>
      <tr><td>{{$t('message.interfaceAudio')}} - {{$t('message.active_ports_mps_and_switch')}}</td><td></td><td>{{ dataCluster.interfaceAudio.poePorts }}</td></tr>
      <tr><td>{{$t('message.panelControl')}} - {{$t('message.active_ports_mps_and_switch')}}</td><td></td><td>{{ dataCluster.panelControl.poePorts }}</td></tr>
    </table>

  </div>
</div>
</template>

<script>
export default {
  name: 'DaneKlastra',
  props: ['dataCluster', 'numer'],
  data () {
    return {
    }
  }
}
</script>

<style>
div#tabela-klaster {
  margin: 5px 0px;
}
div#tabela-klaster table {
  margin: 5px 0px;
  width:90%;font-size: 12px;
}
div#tabela-klaster table tr th{
background: #f0f0f0;
font-weight: lighter;
padding: 2px;
}
div#tabela-klaster table {
font-weight: lighter;
}
.dane {
  /* height: auto; */
}
.midd {
  text-align: center;
}
.short {
  width: 70px;
}
</style>



// WEBPACK FOOTER //
// src/components/Views/ClusterView.vue